export const OFFERS_ANCHOR = '#ofertas'

export const PRICE = {
  from: '$19.990 ARS',
  fromShort: '$19.990',
}

export const HERO_BENEFITS = [
  'Planos y medidas',
  'Proyectos prácticos',
  'Recursos de fabricación',
  'Herramientas para cotizar y vender',
]
